<template>
  <v-card :width="200" @click.native="goToUrl(url)">
    <v-card-media v-if="percent">
      <v-flex xs3 offset-xs9>
        <span v-if="percent < 0" class="percent-red">
        {{ percent }}% <v-icon>arrow-drop-down</v-icon>
        </span>
        <span v-else-if="percent == 0" class="percent-black">
        {{ percent }}% <v-icon>arrow-drop-down</v-icon>
        </span>
        <span v-else class="percent-green">
        {{ percent }}% <v-icon>arrow-drop-down</v-icon>
        </span>
      </v-flex>
    </v-card-media>
    <v-card-title>
      <v-flex xs6 offset-xs5>
        <div class="headline">{{ number }}</div>
      </v-flex>
      <v-flex xs7 offset-xs3>
        <div class="grey--text">{{ title }}</div>
      </v-flex>
    </v-card-title>
  </v-card>
</template>

<script>
export default {
  name: 'dashboard-numbers',
  props: {
    title: null,
    number: null,
    percent: null,
    url: null
  },
  methods: {
    goToUrl (url) {
      // console.log('click event fired')
      this.$emit('urlRequested', url)
    }
  }
}
</script>

<style scoped lang="scss">
  div.headline {
    font-weight: 900;
    font-size: 26pt !important;
  }

  div.card {
    max-width: 200px;
    max-height: 125px;
    margin-bottom: 15px;
  }

  .percent-red {
    color: red;
  }

  .percent-black {
    color: black;
  }

  .percent-green {
    color: green;
  }

  .flex.xs3.offset-xs9 {
    text-align: center;
  }
</style>
